import QuizBuilderTabs from "Pages/MySchedule/MyScheduledBeta/quiz/QuizBuilder/components/QuizBuilderTabs";
import React from "react";

const QuizBuilderPage = () => <QuizBuilderTabs />;

export default QuizBuilderPage;
